// extracted by mini-css-extract-plugin
export default {"module":"Favourites_module__tolMB","dark":"Favourites_dark__5Z++0","counter":"Favourites_counter__ns4xo"};